module.exports = __webpack_public_path__ + "static/media/7.17.c5c81f2f.png";